/**
 * Configuration des environnements pour Framerie
 * Gère les URLs selon l'environnement de déploiement
 */

export interface EnvironmentConfig {
  siteUrl: string;
  apiUrl?: string;
  environment: 'development' | 'staging' | 'production';
  isProduction: boolean;
}

/**
 * Détecte l'environnement actuel et retourne la configuration appropriée
 */
export const getEnvironmentConfig = (): EnvironmentConfig => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:';
  
  // Développement local
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return {
      siteUrl: `${protocol}//${hostname}:${window.location.port}`,
      environment: 'development',
      isProduction: false
    };
  }
  
  // Staging sur Render.com
  if (hostname.includes('onrender.com')) {
    return {
      siteUrl: 'https://framerie.onrender.com',
      environment: 'staging',
      isProduction: false
    };
  }
  
  // Production sur Dreambel.tech
  if (hostname.includes('dreambel.tech')) {
    return {
      siteUrl: 'https://framerie.dreambel.tech',
      environment: 'production',
      isProduction: true
    };
  }
  
  // Fallback vers production par défaut
  return {
    siteUrl: 'https://framerie.dreambel.tech',
    environment: 'production',
    isProduction: true
  };
};

/**
 * Configuration actuelle de l'environnement
 */
export const envConfig = getEnvironmentConfig();

/**
 * URLs configurées selon l'environnement
 */
export const SITE_URLS = {
  primary: 'https://framerie.dreambel.tech',
  staging: 'https://framerie.onrender.com',
  development: 'http://localhost:3000'
} as const;

export default envConfig;
